<template>
  <div>
    <div style="width: 1270px; margin: auto">
      <div id="reg-swiper">
        <div class="swiper">
          <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide
              ><div class="swiper-box">
                <div class="swiper-box1">
                  <img src="../assets/images/plant.png" alt="plant" />
                </div>
                <div class="swiper-box2">
                  <h3>Plant</h3>
                  <p>Viridiplantae (1063)</p>
                  <h4>
                    <a href="@/../#/taxonomy?rank=viridiplantae"
                      >Click to browser</a
                    >
                  </h4>
                </div>
              </div></swiper-slide
            >
            <swiper-slide
              ><div class="swiper-box">
                <div class="swiper-box1">
                  <img src="../assets/images/animal.png" alt="animal" />
                </div>
                <div class="swiper-box2">
                  <h3>Animal</h3>
                  <p>Metazoa (2729)</p>
                  <h4>
                    <a href="@/../#/taxonomy?rank=metazoa">Click to browser</a>
                  </h4>
                </div>
              </div></swiper-slide
            >
            <swiper-slide
              ><div class="swiper-box">
                <div class="swiper-box1">
                  <img src="../assets/images/fungi.png" alt="fungi" />
                </div>
                <div class="swiper-box2">
                  <h3>Fungi</h3>
                  <p>Fungi (478)</p>
                  <h4>
                    <a href="@/../#/taxonomy?rank=fungi">Click to browser</a>
                  </h4>
                </div>
              </div></swiper-slide
            >
            <swiper-slide
              ><div class="swiper-box">
                <div class="swiper-box1">
                  <img src="../assets/images/bacteria.png" alt="bacteria" />
                </div>
                <div class="swiper-box2">
                  <h3>Bacteria</h3>
                  <p>Cellular Organisms (2403)</p>
                  <h4>
                    <a href="@/../#/taxonomy?rank=bacteria">Click to browser</a>
                  </h4>
                </div>
              </div></swiper-slide
            >
            <swiper-slide
              ><div class="swiper-box">
                <div class="swiper-box1">
                  <img src="../assets/images/archaea.png" alt="archaea" />
                </div>
                <div class="swiper-box2">
                  <h3>Archaea</h3>
                  <p>Cellular Organisms (156)</p>
                  <h4>
                    <a href="@/../#/taxonomy?rank=archaea">Click to browser</a>
                  </h4>
                </div>
              </div></swiper-slide
            >
            <swiper-slide
              ><div class="swiper-box">
                <div class="swiper-box1">
                  <img src="../assets/images/viruses.png" alt="viruses" />
                </div>
                <div class="swiper-box2">
                  <h3>Viruses</h3>
                  <p>Viruses (1152)</p>
                  <h4>
                    <a href="@/../#/taxonomy?rank=viruses">Click to browser</a>
                  </h4>
                </div>
              </div></swiper-slide
            >
            <!-- 指示点 -->
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- 左右导航栏 -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
      <!--介绍区域-->
      <!--=====================================================================-->

      <h1>Welcome to MbPA !</h1>
      <el-row>
        <el-col :span="10">
          <!--logo-->
          <div class="box">
            <img src="../assets/flow.png" alt="protein" />
            <div class="box-content">
              <h3 class="title">Metalloproteins</h3>
              <span class="post">Introduction</span>
              <p
                style="
                  overflow: hidden;
                  font-family: Helvetica Neue;
                  text-align: justify;
                  line-height: 1.5;
                  margin: auto 15px;
                "
              >
                Metalloproteins are formed by combining proteins and metal ions,
                accounting for one-third of all proteins. Metal ions play an
                important role in the structure and function of proteins: the
                transport of iron ions to hemoglobin; the stabilizing effect of
                zinc ions on protein structure in zinc finger structures; the
                regulating effect of calcium ions on troponin; copper,
                manganese, and cobalt The catalytic effect of ions as enzyme
                cofactors, etc. The realization of these biological functions
                depends on the interaction between the protein and the metal ion
                ligand. The molecular mechanism is the interaction between the
                metal ion ligand and the residue in the protein. As we all know,
                protein sequence determines its structure, and structure
                produces functional information, so the realization of protein
                function is closely related to its sequence information and
                structural information.
              </p>
            </div>
            <br />
            
          </div>
          <!--logo结束--></el-col
        >
        <el-col :span="14">
          <div class="center-region">
            <p></p>
            <p style="text-align: justify; font-size: 18px; line-height: 24px">
              <i><strong style="color: #663300">MbPA</strong> </i> (The
              Metal-binding Protein Atlas) is a knowledgebase dedicated to
              curating proteins in multiple species that incorporate
              metal-binding related protein data, taxonomy and annotation
              information from disparate sources.
            </p>
            <div class="sigma_icon-block icon-block-3 d-block">
              <div class="sigma_icon-block-content">
                <h3>Data content</h3>
                <p style="color: #777">
                  We comprehensively glean and unify sequence and structure
                  information from the three databases: UniProt, PDB, AlphaFold
                  DB, and provide detailed annotation information in combination
                  with other data resources. In the current work, we have
                  collected 106,373 proteins from 8169 species, covering various
                  biological taxonomic fields, including virus, archaea, fungi,
                  bacteria, animal and plant. 
                </p>
                <h3>Data availability</h3>

                <strong>If you find this information helpful：</strong>
                <br />you can get it in two ways, download it directly from the
                <a href="/#/download/" style="color: #4682b4"> download </a
                >interface. If you need more relevant data, we also provide an
                <a href="http://183.175.59.23:8003/docs/" style="color: #191970"
                  >API</a
                >
                interface for direct access.
              </div>
            </div>
            <div class="sigma_icon-block icon-block-3 d-block">
              <div class="icon-wrapper mb-4">
                <i class="text-white flaticon-architecture"></i>
              </div>
              <div class="sigma_icon-block-content"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 物种陈列-->
      <h1>
        <a
          :href="['@/../#/specifity']"
          style="text-decoration: none; color: black"
          >Species Specificity</a
        >
        <span style="padding-right: 20px"></span>
        <a
          :href="['@/../#/specifity']"
          style="text-decoration: none; color: black"
          ><i class="el-icon-search"></i
        ></a>
      </h1>
      <div>
        <el-row :gutter="22" id="spacies">
          <!--Cu-->
          <el-col :span="6" class="spacies">
            <div>
              <div class="icon"><img src="../assets/images/human.svg" /></div>
              <h3>
                <a :href="['@/../#/specifity/?id=Homo sapiens']">Human</a>
              </h3>
              <p>Homo sapiens</p>
            </div>
          </el-col>
          <el-col :span="6" class="spacies">
            <div>
              <div class="icon"><img src="../assets/images/bovine.svg" /></div>
              <h3><a :href="['@/../#/specifity/?id=Bos taurus']">Bovine</a></h3>
              <p>Bos taurus</p>
            </div>
          </el-col>
          <el-col :span="6" class="spacies">
            <div>
              <div class="icon"><img src="../assets/images/sheep.svg" /></div>
              <h3><a :href="['@/../#/specifity/?id=Ovis aries']">Sheep</a></h3>
              <p>Ovis aries</p>
            </div>
          </el-col>
          <el-col :span="6" class="spacies">
            <div>
              <div class="icon"><img src="../assets/images/rat.svg" /></div>
              <h3>
                <a :href="['@/../#/specifity/?id=Rattus norvegicus']">Rat</a>
              </h3>
              <p>Rattus norvegicus</p>
            </div>
          </el-col>
          <el-col :span="6" class="spacies">
            <div>
              <div class="icon"><img src="../assets/images/pig.svg" /></div>
              <h3><a :href="['@/../#/specifity/?id=Sus scrofa']">Pig</a></h3>
              <p>Sus scrofa</p>
            </div> </el-col
          ><el-col :span="6" class="spacies">
            <div>
              <div class="icon"><img src="../assets/images/mouse.svg" /></div>
              <h3>
                <a :href="['@/../#/specifity/?id=Mus musculus']">Mouse</a>
              </h3>
              <p>Mus musculus</p>
            </div>
          </el-col>

          <el-col :span="6" class="spacies">
            <div>
              <div class="icon"><img src="../assets/images/rabbit.svg" /></div>
              <h3>
                <a :href="['@/../#/specifity/?id=Oryctolagus cuniculus']"
                  >Rabbit</a
                >
              </h3>
              <p>Oryctolagus cuniculus</p>
            </div>
          </el-col>
          <el-col :span="6" class="spacies">
            <div>
              <div class="icon"><img src="../assets/images/dog.svg" /></div>
              <h3>
                <a :href="['@/../#/specifity/?id=Canis lupus familiaris']"
                  >Dog</a
                >
              </h3>
              <p>Canis lupus familiaris</p>
            </div>
          </el-col>

          <!--end-->
        </el-row>
      </div>
      <hr />
      <!--物种结束-->
    </div>

    <!-- Clients & Testimonials Start -->
    <div class="section section-padding pt-0 light-bg">
      <div class="container-fluid">
        <div class="section tertiary-bg pattern-building pattern-squares">
          <div class="container">
            <div class="section-title text-center">
              <h6 class="subtitle">
                <span>METAL CATEGORY</span>
              </h6>
            </div>

            <el-row :gutter="22">
              <!--Cu-->
              <el-col :span="6">
                <div
                  class="sigma_icon-block text-center light icon-block-7 light"
                >
                  <div class="icon-wrapper">
                    <span class="stroke-text stroke-text-dark">Mg</span>
                  </div>
                  <div class="sigma_icon-block-content">
                    <h5>Magnesium</h5>
                    <a
                      :href="['@/../#/metal?id=Mg']"
                      style="text-decoration: none"
                      >Proteins (35374)</a
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div
                  class="sigma_icon-block text-center light icon-block-7 light"
                >
                  <div class="icon-wrapper">
                    <span class="stroke-text stroke-text-dark">Zn</span>
                  </div>
                  <div class="sigma_icon-block-content">
                    <h5>Zinc</h5>
                    <a
                      :href="['@/../#/metal?id=Zn']"
                      style="text-decoration: none"
                      >Proteins (29424)</a
                    >
                  </div>
                </div></el-col
              >
              <el-col :span="6">
                <div
                  class="sigma_icon-block text-center light icon-block-7 light"
                >
                  <div class="icon-wrapper">
                    <span class="stroke-text stroke-text-dark">Fe</span>
                  </div>
                  <div class="sigma_icon-block-content">
                    <h5>Iron</h5>
                    <a
                      :href="['@/../#/metal?id=Fe']"
                      style="text-decoration: none"
                      >Proteins (26792)</a
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div
                  class="sigma_icon-block text-center light icon-block-7 light"
                >
                  <div class="icon-wrapper">
                    <span class="stroke-text stroke-text-dark">Mn</span>
                  </div>
                  <div class="sigma_icon-block-content">
                    <h5>Manganese</h5>
                    <a
                      :href="['@/../#/metal?id=Mn']"
                      style="text-decoration: none"
                      >Proteins (7604)</a
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div
                  class="sigma_icon-block text-center light icon-block-7 light"
                >
                  <div class="icon-wrapper">
                    <span class="stroke-text stroke-text-dark">Ca</span>
                  </div>
                  <div class="sigma_icon-block-content">
                    <h5>Calcium</h5>
                    <a
                      :href="['@/../#/metal?id=Ca']"
                      style="text-decoration: none"
                      >Proteins (6126)</a
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div
                  class="sigma_icon-block text-center light icon-block-7 light"
                >
                  <div class="icon-wrapper">
                    <span class="stroke-text stroke-text-dark">K</span>
                  </div>
                  <div class="sigma_icon-block-content">
                    <h5>Potassium</h5>
                    <a
                      :href="['@/../#/metal?id=K']"
                      style="text-decoration: none"
                      >Proteins (2481)</a
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div
                  class="sigma_icon-block text-center light icon-block-7 light"
                >
                  <div class="icon-wrapper">
                    <span class="stroke-text stroke-text-dark">Cu</span>
                  </div>
                  <div class="sigma_icon-block-content">
                    <h5>Copper</h5>
                    <a
                      :href="['@/../#/metal?id=Cu']"
                      style="text-decoration: none"
                      >Proteins (1789)</a
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div
                  class="sigma_icon-block text-center light icon-block-7 light"
                >
                  <div class="icon-wrapper">
                    <span class="stroke-text stroke-text-dark">Co</span>
                  </div>
                  <div class="sigma_icon-block-content">
                    <h5>Cobalt</h5>
                    <a
                      :href="['@/../#/metal?id=Co']"
                      style="text-decoration: none"
                      >Proteins (1328)</a
                    >
                  </div>
                </div>
              </el-col>
              <!--end-->
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <!-- Clients & Testimonials End -->
  </div>
</template>


<style lang="less" scoped>
//引入区域
//@import "../assets/css/plugins/bootstrap.min.css";
@import "../assets/css/style.css";
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 2200px) {
  #reg-swiper {
    width: 2200px;
    margin: auto;
  }
}
//媒体查询
/deep/.swiper-wrapper {
  margin-top: 50px;
}
/deep/.swiper-slide {
  //width:300px;/*设为固定值*/
  height: 320px;
}
.swiper-box {
  height: 90%;
  width: 90%;
  display: flex;
  border-radius: 20px;
  flex-direction: column;
  .swiper-box1 {
    width: 200px;
    margin: auto;
    height: 170px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 20px;
    }
  }
  .swiper-box2 {
    width: 230px;
    margin: auto;

    height: 120px;
    h3 {
      text-align: center;
      margin-bottom: 0;
      //color: #00AADC;
    }
    p {
      margin: 0;
      text-align: center;
    }
    h4 {
      text-align: center;
      background-color: rgb(106, 127, 185);
      border-radius: 5px;
      padding: 5px 0px;
      a {
        text-decoration: none;
        color: white;
        font-size: 17px;
      }
    }
  }
}

.demo {
  background-color: #e4e1d9;
  padding: 50px 0;
}
.box {
  font-family: "Kanit", sans-serif;
  text-align: center;
  border: 10px solid #fff;
  box-shadow: 1px 1px 2px #e6e6e6;
  overflow: hidden;
  position: relative;
}
.box:hover {
  box-shadow: 13px 13px 15px rgba(0, 0, 0, 0.3);
}
.box:before {
  content: "";
  background: linear-gradient(to left top, #70817f, #373d38);
  height: 100%;
  width: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  transition: all 0.4s linear;
}
.box:hover:before {
  opacity: 1;
}
.box img {
  width: 100%;
  height: auto;
  transition: all 0.4s linear;
}
.box:hover img {
  opacity: 0;
  transform: scale(3);
}
.box .box-content {
  color: #fff;
  width: 100%;
  transform: translateY(-50%) scale(0);
  position: absolute;
  top: 50%;
  left: 0;
  transition: all 0.4s linear;
}
.box:hover .box-content {
  transform: translateY(-50%) scale(1);
}
.box .title {
  font-size: 25px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0;
}
.box .post {
  font-size: 16px;
  text-transform: capitalize;
}

.box .icon {
  padding: 0;
  margin: 0;
  list-style: none;
  position: absolute;
  right: 8px;
  bottom: 10px;
}
.box .icon li {
  display: inline-block;
  margin: 0 1px;
  opacity: 0;
  transform: scale(1.3);
  transition: all 0.3s ease 0.4s;
}
.box:hover .icon li {
  opacity: 1;
  transform: scale(1);
}
.box:hover .icon li:nth-child(2) {
  transition: all 0.3s ease 0.2s;
}
.box .icon li a {
  color: #11998e;
  background: #fff;
  font-size: 16px;
  line-height: 33px;
  height: 33px;
  width: 33px;
  border-radius: 50%;
  display: block;
  transition: all 0.5s ease;
}
.box .icon li a:hover {
  color: #fff;
  background-color: #11998e;
  box-shadow: 0 0 5px #000;
}
#spacies {
  margin-top: 15px;
  margin-left: 0px;
  margin-right: 0px;
}
#spacies > .el-col {
  padding: 0px;
}
#spacies > .el-col > div {
  background-color: #fafafa;
  text-align: center;
  border-radius: 0;
  border: 1px solid #eeeeee;
  border-top-color: #d6d3d3;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 5px;
  padding-right: 10px;
  margin-bottom: 20px;
  margin-left: 0px;
  margin-right: 2px;
}
#spacies h3 {
  margin-top: 8px;
  margin-bottom: 2px;
  font-size: 25px;
}
#spacies a {
  color: #6f858b;
  text-decoration: none;
}
#spacies a:hover,
#spacies a:focus {
  text-decoration: none;
}
#spacies p {
  color: #999;
  font-size: 7px;
  margin-bottom: 0px;
  padding-bottom: 5px;
}
.icon {
  float: left;
  margin-left: 50px;
  width: 60px;
  height: 70px;
  color: #a6bfc7;
  background-color: #dff2fc;
  border-radius: 50%;
  cursor: pointer;
}
.icon > img {
  height: 75px;
}
</style>

<script>
export default {
  name: "carrousel",
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        grabCursor: true,
        centerInsufficientSlides: true,
        //spaceBetween : 70,
        //slidesOffsetBefore : 70,
        // slidesOffsetAfter : 70,
        roundLengths: true,
        loop: true,
        //loopedSlides: 5,
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },

        //
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        //
        //断点设定
        breakpoints: {
          1600: {
            //当屏幕宽度小于于等于1570
            slidesPerView: 4,
          },

          2200: {
            //当屏幕宽度小于等于1270
            slidesPerView: 4,
          },
        },
      }, //
      //swiperOption结束
    };
  },
  //定义swiper对象

  //
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.swiper.slideTo(0, 1000, false);
  },
};
</script>
